/**
 * CODE LANGUAGE (CONTEXT-DOCS.md §P4) — one map from a file extension to the highlighter grammar + the label people
 * read. Shared by the code panel (stream), the snippet dialog (composer) and chat code fences. Pure.
 */
const LANGS = [
  // [extensions, highlighter grammar, label]
  [['py'], 'python', 'Python'],
  [['json', 'jsonl', 'ndjson', 'geojson'], 'json', 'JSON'],
  [['yaml', 'yml'], 'yaml', 'YAML'],
  [['js', 'jsx', 'mjs', 'cjs'], 'javascript', 'JavaScript'],
  [['ts', 'tsx'], 'typescript', 'TypeScript'],
  [['sh', 'bash', 'zsh'], 'bash', 'Shell'],
  [['sql'], 'sql', 'SQL'],
  [['go'], 'go', 'Go'],
  [['rs'], 'rust', 'Rust'],
  [['rb'], 'ruby', 'Ruby'],
  [['java'], 'java', 'Java'],
  [['kt', 'kts'], 'kotlin', 'Kotlin'],
  [['scala'], 'scala', 'Scala'],
  [['c', 'h'], 'c', 'C'],
  [['cc', 'cpp', 'hpp'], 'cpp', 'C++'],
  [['cs'], 'csharp', 'C#'],
  [['php'], 'php', 'PHP'],
  [['swift'], 'swift', 'Swift'],
  [['ps1'], 'powershell', 'PowerShell'],
  [['xml', 'html', 'htm', 'xhtml', 'svg', 'vue', 'svelte'], 'xml', 'XML / HTML'],
  [['toml', 'ini', 'cfg', 'conf', 'properties', 'env'], 'ini', 'Config'],
  [['tf', 'tfvars', 'hcl', 'bicep'], 'plaintext', 'Terraform / HCL'],
  [['gradle', 'groovy'], 'groovy', 'Groovy'],
  [['dockerfile'], 'dockerfile', 'Dockerfile'],
  [['graphql', 'gql'], 'graphql', 'GraphQL'],
  [['proto'], 'plaintext', 'Protobuf'],
  [['r'], 'r', 'R'],
  [['pl'], 'perl', 'Perl'],
  [['lua'], 'lua', 'Lua'],
];
const BY_EXT = new Map();
for (const [exts, grammar, label] of LANGS) for (const e of exts) BY_EXT.set(e, { ext: e, grammar, label });

/** "deploy.py" → "py" (lower-case, '' when none). */
export function extOf(name = '') {
  const n = String(name).trim().toLowerCase();
  return n.includes('.') ? n.split('.').pop() : '';
}

/** The language of a CODE file by its name → {ext, grammar, label}, or null (not code we show as a code panel). */
export function codeLangOf(name = '') {
  return BY_EXT.get(extOf(name)) || null;
}

/** A fence tag ("py", "python", "yaml") → the grammar to highlight with ('' = let the highlighter decide). */
export function grammarOfFence(tag = '') {
  const t = String(tag).trim().toLowerCase();
  if (!t) return '';
  const byExt = BY_EXT.get(t);
  if (byExt) return byExt.grammar;
  return t;
}

/** The snippet dialog's type choices — one per language, its first (canonical) extension. Plain text first. */
export const SNIPPET_TYPES = [{ ext: 'txt', label: 'Plain text', grammar: 'plaintext' },
  ...LANGS.map(([exts, grammar, label]) => ({ ext: exts[0], label, grammar }))];

/** "notes" + "py" → "notes.py"; "x.json" + "py" → "x.py". */
export function withExt(name = '', ext = 'txt') {
  const n = String(name).trim() || 'snippet';
  const base = n.includes('.') ? n.slice(0, n.lastIndexOf('.')) || 'snippet' : n;
  return `${base}.${ext}`;
}
